import { render, staticRenderFns } from "./base-page.vue?vue&type=template&id=565594dc&scoped=true"
import script from "./base-page.vue?vue&type=script&lang=js"
export * from "./base-page.vue?vue&type=script&lang=js"
import style0 from "./base-page.vue?vue&type=style&index=0&id=565594dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565594dc",
  null
  
)

export default component.exports